"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Disclaimer_meta_1 = require("../Disclaimer.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('span', Disclaimer_meta_1.DISCLAIMER_CATEGORY_KEY, Disclaimer_meta_1.DISCLAIMER_COMPONENT_KEY, ['separator']);